module.exports = __webpack_public_path__ + "img/Troja-restaurant-5.14eec09a.jpg";